module.exports = "<p>\n  home works!\n</p>\n"